import { Homepage, MlbPickle, NotFound } from './components/pages';

export const routes = [
  {
    path: '/',
    element: <Homepage />,
  },
  {
    path: '/games/pickle',
    element: <MlbPickle />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
